import Worker from 'Lib/worker/PrimusWorker';

import { AccountAddressDetails, CreatePledgeFormAction } from '../../overlays/createPledge/createPledgeForm/CreatePledgeFormReducer';
import { ICreatePledgeFormValues } from '../../overlays/createPledge/createPledgeForm/types';

export const getAccount = async (account, currency) => await Worker.getInstance()
    .getAccount(account, currency);
export const getTransactionsSync = async (params) => {
    return await Worker.getInstance()
        .getTransactionsSync(params);
};
export const validateWalletAddressWithCore = async (
    values: ICreatePledgeFormValues,
    dispatchFormAction: React.Dispatch<CreatePledgeFormAction>
) => {
    try {
        dispatchFormAction({ type: 'VALIDATING_ACCOUNT' });
        const response = await Worker.getInstance()
            .getWalletAddressDetails({
                WalletAddress: values.RecipientAddress,
                SenderAddress: values.Sender.Account
            });

        if (response.data.Status === 49) {
            return 'Account is invalid or unable to receive';
        } else if (response.data.Account) {
            const walletAddressDetails: AccountAddressDetails = {
                Account: response.data.Account || '',
                AccountId: response.data.AccountId || '',
                AccountName: response.data.AccountName || '',
                FirmName: response.data.FirmName || '',
                FirmId: response.data.FirmId || ''
            };

            return walletAddressDetails;
        } else {
            return 'Could not validate recipient address, please try again';
        }
    } catch (error) {
        return 'Could not validate recipient address, please try again';
    }
};